import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Link from "../../Link";

const CheckoutPodcasts = ({ title, btnViewAllPodcast }) => {
  const data = useStaticQuery(graphql`
    query {
      googlePodcastIcon: file(
        relativePath: { eq: "images/google-podcasts.svg" }
      ) {
        publicURL
      }
      soundCloudIcon: file(relativePath: { eq: "images/soundcloud.png" }) {
        publicURL
      }
    }
  `);

  return (
    <>
      <div className="container">
        <div className="checkout-podcasts">
          <div className="checkout-podcasts-inner">
            <div className="row">
              <div className="col-12 col-lg-6">
                <h2>{title}</h2>
                <Link
                  to={`/learn/filtration/?topic=podcasts`}
                  className="button button-secondary button-buy text-center mt-4 mb-4 mb-lb-0"
                  type="button"
                >
                  {btnViewAllPodcast} &#8594;
                </Link>
              </div>
              <div className="col-12 col-sm-6 col-lg-3 mb-3 mb-sm-0">
                <a
                  id="podcasts-google"
                  href="https://podcasts.google.com/feed/aHR0cDovL2ZlZWRzLnNvdW5kY2xvdWQuY29tL3VzZXJzL3NvdW5kY2xvdWQ6dXNlcnM6NTEwMTk3MTkzL3NvdW5kcy5yc3M/episode/dGFnOnNvdW5kY2xvdWQsMjAxMDp0cmFja3MvODY2MzgxMjIx?sa=X&ved=0CAUQkfYCahcKEwiYxOa42YvtAhUAAAAAHQAAAAAQAQ"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  <div className="card-dark h-custom d-flex flex-column align-items-center justify-content-center">
                    <img
                      src={data.googlePodcastIcon.publicURL}
                      alt="Google Podcasts"
                      className="img-fluid g-podcasts"
                    />
                    <div className="text-center">Google Podcasts</div>
                  </div>
                </a>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <a
                  href="https://soundcloud.com/zipmexthailand"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  <div className="card-dark h-custom d-flex flex-column align-items-center justify-content-center">
                    <img
                      src={data.soundCloudIcon.publicURL}
                      alt="SoundCloud"
                      className="img-fluid soundcloud"
                    />
                    <div className="text-center">SoundCloud</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckoutPodcasts;
